import React, { useEffect, useState } from 'react';
import { Row, Col, Spinner, Form, Button, Alert } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const Info = withReactContent(Swal);
const leaders = [
    '1357797105955242075',
    '1357797133100777643',
];
const AwardList = () => {
    const [awards, setAwards] = useState(null);
    const [isLeader, setisLeader] = useState(false);
    const awardOptions = [
        {
            label: 'Řád Zlatého života',
            reason: 'Za hrdinskou záchranu života v extrémních nebo životu nebezpečných podmínkách.'
        },
        {
            label: 'Čestná medaile EMS',
            reason: 'Za dlouhodobé příkladné chování, odbornost a reprezentaci hodnot EMS.'
        },
        {
            label: 'Plaketa hlavního lékaře',
            reason: 'Za mimořádný profesní výkon uznaný vedením lékařského oddělení.'
        },
        {
            label: 'Zásah roku',
            reason: 'Za mimořádný a precizně vedený zásah, který vynikl nad rámec běžné služby.'
        },
        {
            label: 'Medaile za klinickou dokonalost',
            reason: 'Za perfektní technické provedení zdravotního zákroku v kritické situaci.'
        },
        {
            label: 'Cena za humanitární přístup',
            reason: 'Za výjimečně lidský, empatický a etický přístup k pacientům ve stresových situacích.'
        },
        {
            label: 'Ocenění za profesní růst',
            reason: 'Za významné zlepšení odborných dovedností a aktivní přístup ke vzdělávání.'
        },
        {
            label: 'Diplom za vedení a mentorství',
            reason: 'Za efektivní vedení kolegů, výcvik nováčků a posilování EMS týmového ducha.'
        },
        {
            label: 'Týmová hvězda EMS',
            reason: 'Za mimořádnou spolupráci při složitém výjezdu a příkladné týmové chování.'
        },
        {
            label: 'Mimořádné nasazení',
            reason: 'Za nasazení nad rámec očekávání a službu v náročných podmínkách bez zaváhání.'
        }
    ];

    const [form, setForm] = useState({
        name: '',
        award: '',
        reason: '',
        image: null
    });

    const handleAwardSelect = (e) => {
        const selected = e.target.value;
        const found = awardOptions.find(opt => opt.label === selected);
        setForm(prev => ({
            ...prev,
            award: selected,
            reason: found ? found.reason : ''
        }));
    };

    useEffect(() => {
        const raw = localStorage.getItem('ems_member');
        if (raw) {
            const parsed = JSON.parse(raw);
            const roles = parsed.user.roles;
            const hasLeaderRole = roles.some(role => leaders.includes(role));
            setisLeader(hasLeaderRole);
        }

        fetch('https://ems.lexikonn.eu/api/get_awards.php')
            .then(res => res.json())
            .then(data => setAwards(data));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleImage = (e) => {
        setForm(prev => ({ ...prev, image: e.target.files[0] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.image) {
            return Info.fire({ icon: 'warning', title: 'Chybí obrázek!' });
        }

        const imgForm = new FormData();
        imgForm.append('image', form.image);

        const imgurRes = await fetch('https://api.imgur.com/3/image', {
            method: 'POST',
            headers: {
                Authorization: 'Client-ID 16f2bc8fda9db18',
            },
            body: imgForm
        });

        const imgData = await imgurRes.json();
        const imageUrl = imgData.data.link;

        fetch('https://ems.lexikonn.eu/api/add_award.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                name: form.name,
                award: form.award,
                reason: form.reason,
                image_url: imageUrl
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    Info.fire({ icon: 'success', title: 'Uloženo!' });
                    setForm({ name: '', award: '', reason: '', image: null });
                    fetch('https://ems.lexikonn.eu/api/get_awards.php')
                        .then(res => res.json())
                        .then(data => setAwards(data));
                } else {
                    Info.fire({ icon: 'error', title: 'Chyba při ukládání' });
                }
            });
    };

    return (
        <div className="container py-5">
            <h2 className="mb-4">🎖️ Ocenění členů EMS</h2>

            {isLeader && (
                <div className="mb-5 box">
                    <h4 className="mb-3">Přidat ocenění</h4>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Jméno oceněného</Form.Label>
                            <Form.Control type="text" name="name" value={form.name} onChange={handleChange} required />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Název ocenění</Form.Label>
                            <Form.Select name="award" value={form.award} onChange={handleAwardSelect} required>
                                <option value="">-- Vyber ocenění --</option>
                                {awardOptions.map((opt, i) => (
                                    <option key={i} value={opt.label}>{opt.label}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Za co</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="reason"
                                value={form.reason}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Fotka</Form.Label>
                            <Form.Control type="file" onChange={handleImage} accept="image/*" required />
                        </Form.Group>

                        <Button variant="danger" type="submit">Uložit ocenění</Button>
                    </Form>
                </div>
            )}

            {!awards ? (
                <div className="text-center py-5"><Spinner animation="border" /></div>
            ) : (
                <Row className="gy-4">
                    {awards.map((a, i) => (
                        <Col xs={12} sm={6} lg={4} key={i}>
                            <div className="ems-award-block" style={{ backgroundImage: `url(${a.image_url})` }}>
                                <div className="ems-award-overlay">
                                    <div className="ems-award-title">{a.award}</div>
                                    <div className="ems-award-name">{a.name}</div>
                                    <div className="ems-award-reason">{a.reason}</div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            )}
        </div>
    );
};

export default AwardList;
